import {FormattedMessage} from 'react-intl';
import React from 'react';

export const roleMap = {
    'PRIMARY': <FormattedMessage id={'labels.PRIMARY'} />,
    'ASSOCIATE': <FormattedMessage id={'labels.ASSOCIATE'} />,
    'CO_BORROWER': <FormattedMessage id={'labels.CO-BORROWER'} />,
    'GUARANTOR': <FormattedMessage id={'labels.GUARANTOR'} />,
    'ON DEMAND': <FormattedMessage id={'labels.ON_DEMAND'} />,
    'PROXY': <FormattedMessage id={'labels.PROXY'} />,
    'DEALER': <FormattedMessage id={'labels.DEALER'} />,
    'JDF SIGNER': <FormattedMessage id={'labels.JDF_SIGNER'} />
}
export const errorMsgMap = {
    'you can only assign': <FormattedMessage id={'labels.you can only assign'} />,
    'representatives to the': <FormattedMessage id={'labels.representatives to the'} />
}
export const signingOptionMap = {
    'SIGN BY EMAIL': <FormattedMessage id={'labels.SIGN_BY_EMAIL'} />,
    'SIGN NOW': <FormattedMessage id={'labels.SIGN_NOW'} />
}

export const envelopeStatusMap = {
    'COMPLETED':  'labels.COMPLETED',
    'CREATED': 'labels.CREATED',
    'DECLINED': 'labels.DECLINED',
    'DELETED': 'labels.DELETED',
    'DELIVERED': 'labels.DELIVERED',
    'PROCESSING': 'labels.PROCESSING',
    'SENT': 'labels.SENT',
    'SIGNED': 'labels.SIGNED',
    'TEMPLATE': 'labels.TEMPLATE',
    'VOIDED': 'labels.VOIDED'
}

export const quoteStatusMap = {
    'AUTO-APPROVED': <FormattedMessage id={'labels.AUTO_APPROVED'} />,
    'AWAITING FURTHER INFORMATION/DOCUMENTS': <FormattedMessage id={'labels.AWAITING_FURTHER_INFORMATION_DOCUMENTS'} />,
    'APPROVED': <FormattedMessage id={'labels.APPROVED'} />,
    'APPROVED WITH CONDITIONS': <FormattedMessage id={'labels.APPROVED_WITH_CONDITIONS'} />,
    'CREDIT DECISION ROUTED FOR MANUAL REVIEW': <FormattedMessage id={'labels.CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW'} />,
    'CONTRACT PAID OFF': <FormattedMessage id={'labels.CONTRACT_PAID_OFF'} />,
    'DECLINED': <FormattedMessage id={'labels.DECLINED'} />,
    'DELETED': <FormattedMessage id={'labels.DELETED'} />,
    'EXPIRED': <FormattedMessage id={'labels.EXPIRED'} />,
    'PROPOSED': <FormattedMessage id={'labels.PROPOSED'} />,
    'QUOTE': <FormattedMessage id={'labels.QUOTE'} />,
    'SUBMITTED': <FormattedMessage id={'labels.SUBMITTED'} />,
    'WITHDRAWN': <FormattedMessage id={'labels.WITHDRAWN'} />
}
